import { __exports as r } from "../../../../../../../../_virtual/sanitizer2.js";
import { __require as a } from "../../../../../../@braintree_sanitize-url@7.0.2/bundled_deps/@braintree/sanitize-url/dist/index.js";
var i;
function o() {
  if (i) return r;
  i = 1, Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.sanitizeUrl = n;
  var t = a();
  function n(e) {
    return e && (0, t.sanitizeUrl)(e);
  }
  return r;
}
export {
  o as __require
};
